import React from 'react';

import Button from './Button';

const SecondaryButton = ({ children, className, type, onClick }) =>
  <Button type={type} isPrimary={false} onClick={onClick} className={className}>{children}</Button>;

export default SecondaryButton;